import React from 'react';
import { Outlet } from 'react-router-dom';

export const AdminTenantLayout: React.FC = () => {
  return <Outlet />;
};
